import React from "react";
import AvatarPng from "@components/avatar/avatr.png";

const UsersCard = (props) => {
  const { user } = props;
  const role = user?.roles?.length ? user.roles[0].name : "";
  return (
    <div
      className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 pd1"
      style={{ minWidth: "350px" }}
    >
      <div
        style={{ backgroundColor: "tomato", alignItems: "center" }}
        className="treanding_slider_main_box release_box_main_content ms_cover"
      >
        <img
          style={{ height: "100%", width: "100%", objectFit: "cover" }}
          src={user.avatar ? user.avatar : AvatarPng}
          alt="img"
        />
        <div
          className="release_content_artists"
          style={{ height: "80px", opacity: "0.9" }}
        >
          <p
            style={{ cursor: "pointer", fontWeight: "bold", fontSize: "25px" }}
          >{`${user?.first_name} ${user.last_name}`}</p>
          <p
            style={{ cursor: "pointer", marginTop: "5px" }}
            className="various_artist_text"
          >
            {role}
          </p>
        </div>
      </div>
    </div>
  );
};

export default UsersCard;
